import React, { useRef, useState, useEffect } from "react";
import JoditEditor from "jodit-react";

const DescriptionEditor = ({ value, onChange, placeholder }) => {
  const editor = useRef(null);
  const [content, setContent] = useState(value || "");

  useEffect(() => {
    // Update state if external value changes
    setContent(value || "");
  }, [value]);

  const handleBlur = (newContent) => {
    setContent(newContent);
    if (onChange) {
      onChange(newContent);
    }
  };

  return (
    <JoditEditor
      ref={editor}
      value={content}
      config={{
        readonly: false,
        placeholder: placeholder || "Start typing...",
        height: 600,
        toolbarAdaptive: false,
        toolbarSticky: false,
         removeButtons: ["fullsize"],
      }}
      onBlur={handleBlur}
      
    />
  );
};

export default DescriptionEditor;
